module.exports = __webpack_public_path__ + "img/19.3f3c5ae5.png";